import { render, staticRenderFns } from "./ConfirmToChange.vue?vue&type=template&id=c15b8c3a&"
import script from "./ConfirmToChange.vue?vue&type=script&lang=js&"
export * from "./ConfirmToChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports